import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import { Margin } from '@mui/icons-material';

export default function AboutUsComponent() {
  return (
    <Card
      style={{
        display: 'flex',
        flexDirection: 'row',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        maxWidth: '100%',
        width: '100%',
        overflow: 'hidden', // Ensures the image does not overflow the card boundaries
      }}
    >
      <Box
        style={{
          flex: 1,
          padding: '16px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          Margin:'0px',
          padding:'0px'
        }}
      >
        <Typography variant="body1">
        <h6>We are a premier  Taxi/Cab service in salem,Cabs offering reliable and comfortable rides to all destinations</h6>. Our fleet of well-maintained vehicles and professional drivers ensure that you have a pleasant travel experience. Whether you need a ride to the airport, a business meeting, or a night out, we are here to provide you with the best service possible.
        </Typography>
      </Box>
      <Box
        style={{
          flex: 1,
          minWidth: '200px',
          position: 'relative',
        }}
      >
        <img
          src="/images/login/Dashboard/Assert/about_side_image.webp"
          alt="Taxi Service"
          style={{ 
            width: '100%', 
            height: '100%', 
            objectFit: 'cover', 
            display: 'block'
          }}
        />
      </Box>
    </Card>
  );
}